import { render, staticRenderFns } from "./RoomStatusManagementPopup.vue?vue&type=template&id=96d39154&scoped=true&"
import script from "./RoomStatusManagementPopup.vue?vue&type=script&lang=js&"
export * from "./RoomStatusManagementPopup.vue?vue&type=script&lang=js&"
import style0 from "./RoomStatusManagementPopup.vue?vue&type=style&index=0&id=96d39154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d39154",
  null
  
)

export default component.exports